import { Component, OnInit, HostBinding, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatInput } from '@angular/material';
export interface PromptDialogData {
	title: string;
	prompt: string;
	value: string;
}
@Component({
	selector: 'common-prompt-dialog',
	templateUrl: './prompt-dialog.component.html',
	styleUrls: ['./prompt-dialog.component.scss']
})
export class PromptDialogComponent implements OnInit {
	@HostBinding('class.c-prompt-dialog') hostClass = true;
	inputString: string;
	constructor(
		public dialogRef: MatDialogRef<PromptDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: PromptDialogData
	) {}

	onNoClick(): void {
		this.dialogRef.close();
	}

	ngOnInit() {}
}
